<template>
  <b-badge
    qa="status-badge"
    class="state-badge"
    pill
    :class="statusClass"
  >
    {{ label }}
  </b-badge>
</template>

<script>

import { CASE_STATES } from '@/api/resources/entityState/case-state'

export default {
    name: 'CommonCaseStatusBadge',
    props: {
        status: { type: Object, required: true },
        labelField: { type: String, default: 'name' }
    },
    data() {
        return {
            invalidStatus: { bgColor: 'red', color: 'white', label: 'global.statusOptions.invalid' }
        }
    },
    computed: {
        label() {
            return this.status[this.labelField]
        },
        statusClass() {
            return this.statusOption.class
        },
        statusOption() {
            const state = Object.values(CASE_STATES).find(state => state.code === this.status.code)
            return state ?? this.invalidStatus
        }
    }
}

</script>
